import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import paymaya from 'paymaya-js-sdk';

function Payment() {
  const query = new URLSearchParams(useLocation().search);
  const amount = query.get('amount');
  const reference = query.get('reference');

  const createCheckout = async (response) => {
    try {
      paymaya.init('pk-eCQhSLBM5dpceG1GldjSbUMuM9dVREqcU20f3qSv88U', false);
      await paymaya.createCheckout(response);
    } catch (err) {
      console.error('Error creating checkout:', err);
    }
  };

  useEffect(() => {
    if (amount && reference) {
      const checkoutData = {
        requestReferenceNumber: reference,
        totalAmount: {
          value: amount,
          currency: 'PHP',
        },
        redirectUrl: {
          success: "http://localhost:3001",
          failure: "http://localhost:3001",
          cancel: "http://localhost:3001",
        },
      };

      createCheckout(checkoutData);
    }
  }, [amount, reference]);

  return (
    <div>
      <h1>Processings...</h1>
    </div>
  );
}

export default Payment;